(function () {
  function initLazyVideos(root) {
    var videos = root.querySelectorAll('video[data-vsl-src]');
    if (!videos.length) return;

    var loadVideo = function (video) {
      if (video.dataset.vslLoaded === 'true') return;
      var source = document.createElement('source');
      source.src = video.dataset.vslSrc;
      source.type = video.dataset.vslType || 'video/mp4';
      video.appendChild(source);
      video.dataset.vslLoaded = 'true';
      video.load();
      if (video.hasAttribute('autoplay')) {
        video.play().catch(function () {});
      }
    };

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '260px 0px' });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function initQuiz(root) {
    root.querySelectorAll('[data-vsl-quiz]').forEach(function (quiz) {
      var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-vsl-step]'));
      var resultCards = Array.prototype.slice.call(quiz.querySelectorAll('[data-vsl-result]'));
      var progress = quiz.querySelector('[data-vsl-progress]');
      var answers = {};
      var active = 0;

      function showStep(index) {
        active = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach(function (step, stepIndex) {
          step.hidden = stepIndex !== active;
        });
        if (progress) {
          progress.style.setProperty('--vsl-progress', ((active + 1) / steps.length) * 100 + '%');
        }
      }

      function scoreResults() {
        var scores = { energy: 0, recovery: 0, longevity: 0, performance: 0 };
        Object.keys(answers).forEach(function (key) {
          var value = answers[key];
          if (scores[value] !== undefined) scores[value] += 1;
        });

        var winner = Object.keys(scores).sort(function (a, b) {
          return scores[b] - scores[a];
        })[0] || 'performance';

        resultCards.forEach(function (card) {
          card.hidden = card.dataset.vslResult !== winner;
        });

        quiz.querySelectorAll('[data-vsl-result-wrap]').forEach(function (wrap) {
          wrap.hidden = false;
        });
      }

      quiz.addEventListener('click', function (event) {
        var option = event.target.closest('[data-vsl-answer]');
        var back = event.target.closest('[data-vsl-back]');
        var restart = event.target.closest('[data-vsl-restart]');

        if (option) {
          answers[option.dataset.vslQuestion] = option.dataset.vslAnswer;
          option.closest('[data-vsl-step]').querySelectorAll('[data-vsl-answer]').forEach(function (button) {
            button.classList.toggle('is-selected', button === option);
          });
          if (active < steps.length - 1) {
            showStep(active + 1);
          } else {
            scoreResults();
            quiz.querySelectorAll('[data-vsl-step-wrap]').forEach(function (wrap) {
              wrap.hidden = true;
            });
          }
        }

        if (back) showStep(active - 1);

        if (restart) {
          answers = {};
          quiz.querySelectorAll('[data-vsl-step-wrap]').forEach(function (wrap) {
            wrap.hidden = false;
          });
          quiz.querySelectorAll('[data-vsl-result-wrap]').forEach(function (wrap) {
            wrap.hidden = true;
          });
          quiz.querySelectorAll('[data-vsl-answer]').forEach(function (button) {
            button.classList.remove('is-selected');
          });
          showStep(0);
        }
      });

      showStep(0);
    });
  }

  function initStickyBars(root) {
    root.querySelectorAll('[data-vsl-sticky-bar]').forEach(function (bar) {
      if (bar.dataset.vslInit === 'true') return;
      bar.dataset.vslInit = 'true';

      var threshold = Number(bar.dataset.threshold || 420);
      var cartFooter = document.querySelector('.cart__footer, .cart-drawer__footer, [name="checkout"]');

      function update() {
        var pastThreshold = window.scrollY > threshold;
        var nearCheckout = false;

        if (cartFooter) {
          var rect = cartFooter.getBoundingClientRect();
          nearCheckout = rect.top < window.innerHeight && rect.bottom > 0;
        }

        bar.classList.toggle('is-visible', pastThreshold && !nearCheckout);
      }

      update();
      document.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  function init(root) {
    initLazyVideos(root || document);
    initQuiz(root || document);
    initStickyBars(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
